export type SummaryData = {
  amount: number;
  label: string;
  chartColor: string;
};

export enum SummaryUnit {
  BRL_CURRENCY = "currency:brl"
}

export type ISummaryCardPros = {
  summaries: Array<SummaryData>;
  isScrollable?: boolean;
  unit?: SummaryUnit;
  title: string;
  titleIcon: string;
  iconVariant?: "solid" | "regular";
  date: Date;
  variant?: SummaryCardVariant;
  width?: number | string;
};

export enum SummaryCardVariant {
  primary = "primary",
  secondary = "secondary",
  blank = "blank"
}
